import * as React from 'react';
// Ideally, we would import from the folder rather than deep imports.
// However, the icons package is very expensive to parse for the TypeScript compiler for this package AND its dependencies.
// The TSX files that are imported from are auto-generated during this package's build step. Run `yarn build --to icons` from repo root if there are import errors
import SvgAccounts from '../temp/Accounts.gen';
import SvgActivityFeed from '../temp/ActivityFeed.gen';
import SvgAddCircle from '../temp/AddCircle.gen';
import SvgAddFriend from '../temp/AddFriend.gen';
import SvgAlignLeft from '../temp/AlignLeft.gen';
import SvgAlignRight from '../temp/AlignRight.gen';
import SvgArrowBetweenDown from '../temp/ArrowBetweenDown.gen';
import SvgArrowBetweenUp from '../temp/ArrowBetweenUp.gen';
import SvgArrowReply from '../temp/ArrowReply.gen';
import SvgBlocked2 from '../temp/Blocked2.gen';
import SvgBold from '../temp/Bold.gen';
import SvgBulletedList from '../temp/BulletedList.gen';
import SvgBulletedListMirrored from '../temp/BulletedListMirrored.gen';
import SvgCalculatorMultiply from '../temp/CalculatorMultiply.gen';
import SvgCalendarMirrored from '../temp/CalendarMirrored.gen';
import SvgCancel from '../temp/Cancel.gen';
import SvgCheckList from '../temp/CheckList.gen';
import SvgCheckMark from '../temp/CheckMark.gen';
import SvgChevronDown from '../temp/ChevronDown.gen';
import SvgChevronUp from '../temp/ChevronUp.gen';
import SvgChevronLeft from '../temp/ChevronLeft.gen';
import SvgChevronRight from '../temp/ChevronRight.gen';
import SvgClipboardList from '../temp/ClipboardList.gen';
import SvgClipboardListMirrored from '../temp/ClipboardListMirrored.gen';
import SvgClock from '../temp/Clock.gen';
import SvgColumn from '../temp/Column.gen';
import SvgComment from '../temp/Comment.gen';
import SvgCommentAdd from '../temp/CommentAdd.gen';
import SvgCommentDelete from '../temp/CommentDelete.gen';
import SvgCommentDeleteFilled from '../temp/CommentDeleteFilled.gen';
import SvgCompleted from '../temp/Completed.gen';
import SvgCompletedSolid from '../temp/CompletedSolid.gen';
import SvgContact from '../temp/Contact.gen';
import SvgContextMenu from '../temp/ContextMenu.gen';
import SvgCopy from '../temp/Copy.gen';
import SvgCut from '../temp/Cut.gen';
import SvgDecreaseIndent from '../temp/DecreaseIndent.gen';
import SvgDecreaseIndentMirrored from '../temp/DecreaseIndentMirrored.gen';
import SvgDelete from '../temp/Delete.gen';
import SvgDeleteColumns from '../temp/DeleteColumns.gen';
import SvgDeleteRows from '../temp/DeleteRows.gen';
import SvgDeleteTable from '../temp/DeleteTable.gen';
import SvgDocumentLink from '../temp/DocumentLink.gen';
import SvgDown from '../temp/Down.gen';
import SvgDraft from '../temp/Draft.gen';
import SvgDraftFilled from '../temp/DraftFilled.gen';
import SvgEdit from '../temp/Edit.gen';
import SvgEditFilled from '../temp/EditFilled.gen';
import SvgEmoji from '../temp/Emoji.gen';
import SvgError from '../temp/Error.gen';
import SvgErrorBadge from '../temp/ErrorBadge.gen';
import SvgEventDate from '../temp/EventDate.gen';
import SvgForward from '../temp/Forward.gen';
import SvgGripperDotsVertical from '../temp/GripperDotsVertical.gen';
import SvgGroup from '../temp/Group.gen';
import SvgHeader1 from '../temp/Header1.gen';
import SvgHeader2 from '../temp/Header2.gen';
import SvgHeader3 from '../temp/Header3.gen';
import SvgHide3 from '../temp/Hide3.gen';
import SvgHorizontalDivider from '../temp/HorizontalDivider.gen';
import SvgIncreaseIndent from '../temp/IncreaseIndent.gen';
import SvgIncreaseIndentMirrored from '../temp/IncreaseIndentMirrored.gen';
import SvgInfo from '../temp/Info.gen';
import SvgInsert from '../temp/Insert.gen';
import SvgInsertColumnsLeft from '../temp/InsertColumnsLeft.gen';
import SvgInsertColumnsRight from '../temp/InsertColumnsRight.gen';
import SvgInsertRowsAbove from '../temp/InsertRowsAbove.gen';
import SvgInsertRowsBelow from '../temp/InsertRowsBelow.gen';
import SvgInsertTextBox from '../temp/InsertTextBox.gen';
import SvgInsights from '../temp/Insights.gen';
import SvgItalic from '../temp/Italic.gen';
import SvgLink from '../temp/Link.gen';
import SvgLocaleLanguage from '../temp/LocaleLanguage.gen';
import SvgMore from '../temp/More.gen';
import SvgMove from '../temp/Move.gen';
import SvgNumberedList from '../temp/NumberedList.gen';
import SvgNumberedListMirrored from '../temp/NumberedListMirrored.gen';
import SvgOpen from '../temp/Open.gen';
import SvgOpenInNewTab from '../temp/OpenInNewTab.gen';
import SvgPaste from '../temp/Paste.gen';
import SvgRedo from '../temp/Redo.gen';
import SvgRemoveLink from '../temp/RemoveLink.gen';
import SvgReply from '../temp/Reply.gen';
import SvgReplyAlt from '../temp/ReplyAlt.gen';
import SvgReplyMirrored from '../temp/ReplyMirrored.gen';
import SvgSend from '../temp/Send.gen';
import SvgSendMirrored from '../temp/SendMirrored.gen';
import SvgShare from '../temp/Share.gen';
import SvgSort from '../temp/Sort.gen';
import SvgSortFilled from '../temp/SortFilled.gen';
import SvgSortDown from '../temp/SortDown.gen';
import SvgSortUp from '../temp/SortUp.gen';
import SvgSortDownFilled from '../temp/SortDownFilled.gen';
import SvgSortUpFilled from '../temp/SortUpFilled.gen';
import SvgOpsBarSort from '../temp/OpsBarSort.gen';
import SvgStatusCircleBlock from '../temp/StatusCircleBlock.gen';
import SvgStatusCircleInner from '../temp/StatusCircleInner.gen';
import SvgStrikethrough from '../temp/Strikethrough.gen';
import SvgSync from '../temp/Sync.gen';
import SvgTextNumberFormat from '../temp/TextNumberFormat.gen';
import SvgTable from '../temp/Table.gen';
import SvgFabricTextHighlight from '../temp/FabricTextHighlight.gen';
import SvgUnderline from '../temp/Underline.gen';
import SvgUndo from '../temp/Undo.gen';
import SvgUnknown from '../temp/Unknown.gen';
import SvgUnknownReverse from '../temp/UnknownReverse.gen';
import SvgUp from '../temp/Up.gen';
import SvgUpload from '../temp/Upload.gen';
import SvgAdd from '../temp/Add.gen';
import SvgAddFilled from '../temp/AddFilled.gen';
import SvgAltText from '../temp/AltText.gen';
import SvgCalendar from '../temp/Calendar.gen';
import SvgCalendarAgenda from '../temp/CalendarAgenda.gen';
import SvgCircleAdditionSolid from '../temp/CircleAdditionSolid.gen';
import SvgCircleRing from '../temp/CircleRing.gen';
import SvgCode from '../temp/Code.gen';
import SvgPhoto2 from '../temp/Photo2.gen';
import SvgTimeline from '../temp/Timeline.gen';
import SvgBoldBulgarian from '../temp/BoldBulgarian.gen';
import SvgBoldF from '../temp/BoldF.gen';
import SvgBoldG from '../temp/BoldG.gen';
import SvgBoldK from '../temp/BoldK.gen';
import SvgBoldKazakh from '../temp/BoldKazakh.gen';
import SvgBoldKorean from '../temp/BoldKorean.gen';
import SvgBoldN from '../temp/BoldN.gen';
import SvgBoldP from '../temp/BoldP.gen';
import SvgBoldRussian from '../temp/BoldRussian.gen';
import SvgBoldSerbian from '../temp/BoldSerbian.gen';
import SvgBoldT from '../temp/BoldT.gen';
import SvgChecklistMirrored from '../temp/ChecklistMirrored.gen';
import SvgClipboardListQuestion from '../temp/ClipboardListQuestion.gen';
import SvgHideBcc from '../temp/HideBcc.gen';
import SvgItalicC from '../temp/ItalicC.gen';
import SvgItalicD from '../temp/ItalicD.gen';
import SvgItalicK from '../temp/ItalicK.gen';
import SvgItalicKazakh from '../temp/ItalicKazakh.gen';
import SvgItalicKorean from '../temp/ItalicKorean.gen';
import SvgItalicL from '../temp/ItalicL.gen';
import SvgItalicS from '../temp/ItalicS.gen';
import SvgItalicT from '../temp/ItalicT.gen';
import SvgLeftArrowKey from '../temp/LeftArrowKey.gen';
import SvgOfficeCatchUp from '../temp/OfficeCatchUp.gen';
import SvgShowBcc from '../temp/ShowBcc.gen';
import SvgStrikethroughKorean from '../temp/StrikethroughKorean.gen';
import SvgUnderlineA from '../temp/UnderlineA.gen';
import SvgUnderlineKorean from '../temp/UnderlineKorean.gen';
import SvgUnderlineP from '../temp/UnderlineP.gen';
import SvgUnderlineRussian from '../temp/UnderlineRussian.gen';
import SvgUnderlineS from '../temp/UnderlineS.gen';
import SvgUnderlineSerbian from '../temp/UnderlineSerbian.gen';
import SvgOem from '../temp/OEM.gen';
import SvgEventEdit from '../temp/EventEdit.gen';
//import SvgAccountActivity from '../temp/AccountActivity.gen';
import SvgCustomList from '../temp/CustomList.gen';
import SvgCustomListMirrored from '../temp/CustomListMirrored.gen';
import SvgChatBubblesQuestion from '../temp/ChatBubblesQuestion.gen';
import SvgPersonNote from '../temp/PersonNote.gen';
import SvgPictureLibrary from '../temp/PictureLibrary.gen';
import SvgFluentPoll20Filled from '../temp/FluentPoll20Filled.gen';
import SvgVote from '../temp/Vote.gen';
import SvgSearch from '../temp/Search.gen';
import SvgContactList from '../temp/ContactList.gen';
import SvgVideoAdd from '../temp/VideoAdd.gen';
import SvgTableDataTypeRichText from '../temp/TableDataTypeRichText.gen';
import SvgTableDataTypeDuration from '../temp/TableDataTypeDuration.gen';
import SvgTableDataTypeDate from '../temp/TableDataTypeDate.gen';
import SvgTableDataTypeVoting from '../temp/TableDataTypeVoting.gen';
import SvgTableDataTypeCheckbox from '../temp/TableDataTypeCheckbox.gen';
import SvgTableDataTypePerson from '../temp/TableDataTypePerson.gen';
import SvgTableDataTypeNumber from '../temp/TableDataTypeNumber.gen';
import SvgTableMenuInsertIcon from '../temp/TableMenuInsertIcon.gen';
import SvgTableMenuChangeTypeIcon from '../temp/TableMenuChangeTypeIcon.gen';
import SvgTableMenuRenameIcon from '../temp/TableMenuRenameIcon.gen';
import SvgTableMenuDeleteIcon from '../temp/TableMenuDeleteIcon.gen';
import SvgTableDataTypeRichTextFilled from '../temp/TableDataTypeRichTextFilled.gen';
import SvgTableDataTypeDurationFilled from '../temp/TableDataTypeDurationFilled.gen';
import SvgTableDataTypeDateFilled from '../temp/TableDataTypeDateFilled.gen';
import SvgTableDataTypeVotingFilled from '../temp/TableDataTypeVotingFilled.gen';
import SvgTableDataTypePersonFilled from '../temp/TableDataTypePersonFilled.gen';
import SvgTableDataTypeNumberFilled from '../temp/TableDataTypeNumberFilled.gen';
import SvgTableMenuInsertIconFilled from '../temp/TableMenuInsertIconFilled.gen';
import SvgTableMenuChangeTypeIconFilled from '../temp/TableMenuChangeTypeIconFilled.gen';
import SvgTableMenuRenameIconFilled from '../temp/TableMenuRenameIconFilled.gen';
import SvgTableMenuDeleteIconFilled from '../temp/TableMenuDeleteIconFilled.gen';
import SvgFontColor from '../temp/FontColor.gen';
import SvgFontColorKorean from '../temp/FontColorKorean.gen';
import SvgEye from '../temp/Eye.gen';
import SvgEyeFilledSlash from '../temp/EyeFilledSlash.gen';
import SvgEyeSlash from '../temp/EyeSlash.gen';
import SvgFontColorA from '../temp/FontColorA.gen';
import SvgExpand from '../temp/Expand.gen';
import SvgCollapse from '../temp/Collapse.gen';
import SvgGlobe from '../temp/Globe.gen';
import SvgChatMultiple from '../temp/ChatMultiple.gen';
import SvgChatMultipleFilled from '../temp/ChatMultipleFilled.gen';
import SvgFaceSparkle from '../temp/FaceSparkle.gen';
import SvgTag from '../temp/Tag.gen';
import SvgStatusTracker from '../temp/StatusTracker.gen';
import SvgLoopOutline from '../temp/LoopOutline.gen';
import SvgCreateLoopComponent from '../temp/ComponentLoop20Regular.gen';
import SvgTableDataTypeLabel from '../temp/TableDataTypeLabel.gen';
import SvgTrello from '../temp/Trello.gen';
import SvgPreviewLink from '../temp/PreviewLink.gen';
import SvgJira from '../temp/Jira.gen';
import SvgPlanner from '../temp/Planner.gen';
import SvgLinkOptions from '../temp/Options.gen';
import SvgLinkUrlRest from '../temp/LinkUrlRest.gen';
import SvgEmojiAdd from '../temp/EmojiAdd.gen';
import SvgBoardCardViewDetails from '../temp/BoardCardViewDetails.gen';
import SvgBoardCardMove from '../temp/BoardCardMove.gen';
import SvgBoardCardDuplicate from '../temp/BoardCardDuplicate.gen';
import SvgHorizontalMenu from '../temp/HorizontalMenu.gen';
import SvgLogout from '../temp/Logout.gen';
import SvgPersonCircle from '../temp/PersonCircle.gen';
import SvgCopilot from '../temp/Copilot.gen';
import SvgMapFilled from '../temp/MapFilled.gen';
import SvgLightbulbFilled from '../temp/LightbulbFilled.gen';
import SvgPencilDraftFilled from '../temp/PencilDraftFilled.gen';
import SvgChatBubbleSparkleFilled from '../temp/ChatBubbleSparkleFilled.gen';
import SvgSparkleShimmer from '../temp/SparkleShimmer.gen';
import SvgCopilotColorful from '../temp/CopilotColorful.gen';
import SvgThumbLike from '../temp/ThumbLike.gen';
import SvgThumbDislike from '../temp/ThumbDislike.gen';
import SvgThumbLikeFilled from '../temp/ThumbLikeFilled.gen';
import SvgThumbDislikeFilled from '../temp/ThumbDislikeFilled.gen';
import SvgStopCircle from '../temp/StopCircle.gen';
import SvgStatusErrorFull from '../temp/StatusErrorFull.gen';
import SvgCriticalErrorSolid from '../temp/CriticalErrorSolid.gen';
import SvgWarningSolid from '../temp/WarningSolid.gen';
import SvgBoardInsertCard from '../temp/BoardInsertCard.gen';
import SvgUndoThick from '../temp/UndoThick.gen';
import SvgTrelloDisabled from '../temp/TrelloDisabled.gen';
import SvgJiraDisabled from '../temp/JiraDisabled.gen';
import SvgFluentIconWord from '../temp/FluentIconWord.gen';
import SvgFluentIconExcel from '../temp/FluentIconExcel.gen';
import SvgFluentIconPowerPoint from '../temp/FluentIconPowerPoint.gen';
import SvgChatWarning from '../temp/ChatWarning.gen';
import SvgHelp from '../temp/Help.gen';
import SvgHelpMirrored from '../temp/HelpMirrored.gen';
/**
 * These icons require the FFXC prefix to avoid collisions with the other icons.
 * You can find icon names or the raw SVGs on https://iconcloud.design
 */ const icons = {
    // Component Manifest
    FFXCTable: /*#__PURE__*/ React.createElement(SvgTable, null),
    FFXCEventDate: /*#__PURE__*/ React.createElement(SvgEventDate, null),
    FFXCEventDuration: /*#__PURE__*/ React.createElement(SvgTimeline, null),
    FFXCPhoto2: /*#__PURE__*/ React.createElement(SvgPhoto2, null),
    FFXCCalendarAgenda: /*#__PURE__*/ React.createElement(SvgCalendarAgenda, null),
    FFXCAltText: /*#__PURE__*/ React.createElement(SvgAltText, null),
    FFXQuestionAnswer: /*#__PURE__*/ React.createElement(SvgClipboardListQuestion, null),
    FFXCodeSnippet: /*#__PURE__*/ React.createElement(SvgCode, null),
    FFXSignUp: /*#__PURE__*/ React.createElement(SvgPersonNote, null),
    FFXQuickSync: /*#__PURE__*/ React.createElement(SvgCustomList, null),
    FFXFeedbackRequest: /*#__PURE__*/ React.createElement(SvgChatBubblesQuestion, null),
    FFXTeamUpdate: /*#__PURE__*/ React.createElement(SvgContactList, null),
    FFXImageReplace: /*#__PURE__*/ React.createElement(SvgPictureLibrary, null),
    FFXCNudge: /*#__PURE__*/ React.createElement(SvgFaceSparkle, null),
    // Presence
    FFXCPawn: /*#__PURE__*/ React.createElement(SvgContact, null),
    // Labels
    FFXCStatus: /*#__PURE__*/ React.createElement(SvgStatusTracker, null),
    FFXCTag: /*#__PURE__*/ React.createElement(SvgTag, null),
    // Tablero
    FFXCAdd: /*#__PURE__*/ React.createElement(SvgAdd, null),
    FFXCAddFilled: /*#__PURE__*/ React.createElement(SvgAddFilled, null),
    FFXCCalendar: /*#__PURE__*/ React.createElement(SvgCalendar, null),
    FFXCCircleAdditionSolid: /*#__PURE__*/ React.createElement(SvgCircleAdditionSolid, null),
    FFXCCircleRing: /*#__PURE__*/ React.createElement(SvgCircleRing, null),
    FFXCVote: /*#__PURE__*/ React.createElement(SvgVote, null),
    FFXCEditFilled: /*#__PURE__*/ React.createElement(SvgEditFilled, null),
    FFXCStatusTracker: /*#__PURE__*/ React.createElement(SvgStatusTracker, null),
    FFXCDelete: /*#__PURE__*/ React.createElement(SvgDelete, null),
    FFXCGripperDotsHorizontal: /*#__PURE__*/ React.createElement(SvgGripperDotsVertical, null),
    FFXCStatusCircleInner: /*#__PURE__*/ React.createElement(SvgStatusCircleInner, null),
    FFXCSortDown: /*#__PURE__*/ React.createElement(SvgSortDown, null),
    FFXCSortUp: /*#__PURE__*/ React.createElement(SvgSortUp, null),
    FFXCSort: /*#__PURE__*/ React.createElement(SvgSort, null),
    FFXCSortFilled: /*#__PURE__*/ React.createElement(SvgSortFilled, null),
    FFXCSortDownFilled: /*#__PURE__*/ React.createElement(SvgSortDownFilled, null),
    FFXCSortUpFilled: /*#__PURE__*/ React.createElement(SvgSortUpFilled, null),
    FFXCOpsBarSort: /*#__PURE__*/ React.createElement(SvgOpsBarSort, null),
    FFXCInsertRowsAbove: /*#__PURE__*/ React.createElement(SvgInsertRowsAbove, null),
    FFXCInsertRowsBelow: /*#__PURE__*/ React.createElement(SvgInsertRowsBelow, null),
    FFXCInsertColumnsRight: /*#__PURE__*/ React.createElement(SvgInsertColumnsRight, null),
    FFXCInsertColumnsLeft: /*#__PURE__*/ React.createElement(SvgInsertColumnsLeft, null),
    FFXCDeleteRows: /*#__PURE__*/ React.createElement(SvgDeleteRows, null),
    FFXCDeleteColumns: /*#__PURE__*/ React.createElement(SvgDeleteColumns, null),
    FFXCMoveUp: /*#__PURE__*/ React.createElement(SvgUp, null),
    FFXCMoveDown: /*#__PURE__*/ React.createElement(SvgDown, null),
    FFXCMoveRight: /*#__PURE__*/ React.createElement(SvgForward, null),
    FFXCMoveLeft: /*#__PURE__*/ React.createElement(SvgLeftArrowKey, null),
    FFXCOEM: /*#__PURE__*/ React.createElement(SvgOem, null),
    FFXCCheckMark: /*#__PURE__*/ React.createElement(SvgCheckMark, null),
    CheckMark: /*#__PURE__*/ React.createElement(SvgCheckMark, null),
    FFXCReplyAlt: /*#__PURE__*/ React.createElement(SvgReplyAlt, null),
    FFXCCCBRow: /*#__PURE__*/ React.createElement(SvgInsert, null),
    FFXCCCBDelete: /*#__PURE__*/ React.createElement(SvgDeleteTable, null),
    FFXCCCBMove: /*#__PURE__*/ React.createElement(SvgMove, null),
    FFXCCCBColumn: /*#__PURE__*/ React.createElement(SvgColumn, null),
    FFXCTableShowEye: /*#__PURE__*/ React.createElement(SvgEye, null),
    FFXCTableHideEyeSlash: /*#__PURE__*/ React.createElement(SvgEyeSlash, null),
    FFXCTableHideEyeFilledSlash: /*#__PURE__*/ React.createElement(SvgEyeFilledSlash, null),
    FFXCTableDataTypeRichText: /*#__PURE__*/ React.createElement(SvgTableDataTypeRichText, null),
    FFXCTableDataTypeDuration: /*#__PURE__*/ React.createElement(SvgTableDataTypeDuration, null),
    FFXCTableDataTypeDate: /*#__PURE__*/ React.createElement(SvgTableDataTypeDate, null),
    FFXCTableDataTypeVoting: /*#__PURE__*/ React.createElement(SvgTableDataTypeVoting, null),
    FFXCTableDataTypeCheckbox: /*#__PURE__*/ React.createElement(SvgTableDataTypeCheckbox, null),
    FFXCTableDataTypePerson: /*#__PURE__*/ React.createElement(SvgTableDataTypePerson, null),
    FFXCTableDataTypeNumber: /*#__PURE__*/ React.createElement(SvgTableDataTypeNumber, null),
    FFXCTableDataTypeLabel: /*#__PURE__*/ React.createElement(SvgTableDataTypeLabel, null),
    FFXCTableMenuInsertIcon: /*#__PURE__*/ React.createElement(SvgTableMenuInsertIcon, null),
    FFXCTableMenuChangeTypeIcon: /*#__PURE__*/ React.createElement(SvgTableMenuChangeTypeIcon, null),
    FFXCTableMenuRenameIcon: /*#__PURE__*/ React.createElement(SvgTableMenuRenameIcon, null),
    FFXCTableMenuDeleteIcon: /*#__PURE__*/ React.createElement(SvgTableMenuDeleteIcon, null),
    FFXCTableOpsBarOverFlowMenu: /*#__PURE__*/ React.createElement(SvgHorizontalMenu, null),
    FFXCTableDataTypeRichTextFilled: /*#__PURE__*/ React.createElement(SvgTableDataTypeRichTextFilled, null),
    FFXCTableDataTypeDurationFilled: /*#__PURE__*/ React.createElement(SvgTableDataTypeDurationFilled, null),
    FFXCTableDataTypeDateFilled: /*#__PURE__*/ React.createElement(SvgTableDataTypeDateFilled, null),
    FFXCTableDataTypeVotingFilled: /*#__PURE__*/ React.createElement(SvgTableDataTypeVotingFilled, null),
    FFXCTableDataTypePersonFilled: /*#__PURE__*/ React.createElement(SvgTableDataTypePersonFilled, null),
    FFXCTableDataTypeNumberFilled: /*#__PURE__*/ React.createElement(SvgTableDataTypeNumberFilled, null),
    FFXCTableMenuInsertIconFilled: /*#__PURE__*/ React.createElement(SvgTableMenuInsertIconFilled, null),
    FFXCTableMenuChangeTypeIconFilled: /*#__PURE__*/ React.createElement(SvgTableMenuChangeTypeIconFilled, null),
    FFXCTableMenuRenameIconFilled: /*#__PURE__*/ React.createElement(SvgTableMenuRenameIconFilled, null),
    FFXCTableMenuDeleteIconFilled: /*#__PURE__*/ React.createElement(SvgTableMenuDeleteIconFilled, null),
    FFXCExpand: /*#__PURE__*/ React.createElement(SvgExpand, null),
    FFXCCollapse: /*#__PURE__*/ React.createElement(SvgCollapse, null),
    // Tablero -> Board:
    FFXCTableBoardAdd: /*#__PURE__*/ React.createElement(SvgAdd, null),
    FFXCTableBoardOptions: /*#__PURE__*/ React.createElement(SvgMore, null),
    FFXCTableBoardCardViewDetails: /*#__PURE__*/ React.createElement(SvgBoardCardViewDetails, null),
    FFXCTableBoardCardMove: /*#__PURE__*/ React.createElement(SvgBoardCardMove, null),
    FFXCTableBoardCardDuplicate: /*#__PURE__*/ React.createElement(SvgBoardCardDuplicate, null),
    FFXCTableBoardInsertCard: /*#__PURE__*/ React.createElement(SvgBoardInsertCard, null),
    // Scriptor:
    FFXCAccounts: /*#__PURE__*/ React.createElement(SvgAccounts, null),
    FFXCEdit: /*#__PURE__*/ React.createElement(SvgEdit, null),
    FFXCOpen: /*#__PURE__*/ React.createElement(SvgOpen, null),
    FFXCOpenInNewTab: /*#__PURE__*/ React.createElement(SvgOpenInNewTab, null),
    FFXCRemoveLink: /*#__PURE__*/ React.createElement(SvgRemoveLink, null),
    FFXCPreviewLink: /*#__PURE__*/ React.createElement(SvgPreviewLink, null),
    FFXCLinkUrlRest: /*#__PURE__*/ React.createElement(SvgLinkUrlRest, null),
    FFXCLinkOptions: /*#__PURE__*/ React.createElement(SvgLinkOptions, null),
    FFXCIgnoreTableConversion: /*#__PURE__*/ React.createElement(SvgStatusCircleBlock, null),
    FFXCCommentAdd: /*#__PURE__*/ React.createElement(SvgCommentAdd, null),
    FFXCGroup: /*#__PURE__*/ React.createElement(SvgGroup, null),
    FFXCSeeMore: /*#__PURE__*/ React.createElement(SvgReply, null),
    FFXCDocumentLink: /*#__PURE__*/ React.createElement(SvgDocumentLink, null),
    FFXLoopOutline: /*#__PURE__*/ React.createElement(SvgLoopOutline, null),
    FFXCCreateLoopComponent: /*#__PURE__*/ React.createElement(SvgCreateLoopComponent, null),
    // Commanding Surface
    FFXCInsertTextBox: /*#__PURE__*/ React.createElement(SvgInsertTextBox, null),
    FFXCClipboardList: /*#__PURE__*/ React.createElement(SvgClipboardList, null),
    FFXCBulletedList: /*#__PURE__*/ React.createElement(SvgBulletedList, null),
    FFXCNumberedList: /*#__PURE__*/ React.createElement(SvgNumberedList, null),
    FFXCChecklist: /*#__PURE__*/ React.createElement(SvgCheckList, null),
    FFXCCompleted: /*#__PURE__*/ React.createElement(SvgCompleted, null),
    FFXCLink: /*#__PURE__*/ React.createElement(SvgLink, null),
    FFXCUndo: /*#__PURE__*/ React.createElement(SvgUndo, null),
    FFXCRedo: /*#__PURE__*/ React.createElement(SvgRedo, null),
    FFXCCopy: /*#__PURE__*/ React.createElement(SvgCopy, null),
    FFXCPaste: /*#__PURE__*/ React.createElement(SvgPaste, null),
    FFXCBold: /*#__PURE__*/ React.createElement(SvgBold, null),
    FFXCCut: /*#__PURE__*/ React.createElement(SvgCut, null),
    FFXCHeader1: /*#__PURE__*/ React.createElement(SvgHeader1, null),
    FFXCHeader2: /*#__PURE__*/ React.createElement(SvgHeader2, null),
    FFXCHeader3: /*#__PURE__*/ React.createElement(SvgHeader3, null),
    FFXCHorizontalDivider: /*#__PURE__*/ React.createElement(SvgHorizontalDivider, null),
    FFXCItalic: /*#__PURE__*/ React.createElement(SvgItalic, null),
    FFXCMore: /*#__PURE__*/ React.createElement(SvgMore, null),
    FFXCStrikethrough: /*#__PURE__*/ React.createElement(SvgStrikethrough, null),
    FFXCUnderline: /*#__PURE__*/ React.createElement(SvgUnderline, null),
    FFXCChevronDown: /*#__PURE__*/ React.createElement(SvgChevronDown, null),
    FFXCChevronUp: /*#__PURE__*/ React.createElement(SvgChevronUp, null),
    FFXCChevronRight: /*#__PURE__*/ React.createElement(SvgChevronRight, null),
    FFXCChevronLeft: /*#__PURE__*/ React.createElement(SvgChevronLeft, null),
    FFXCEyeSlash: /*#__PURE__*/ React.createElement(SvgHide3, null),
    FFXCCompletedSolid: /*#__PURE__*/ React.createElement(SvgCompletedSolid, null),
    FFXCIncreaseIndent: /*#__PURE__*/ React.createElement(SvgIncreaseIndent, null),
    FFXCDecreaseIndent: /*#__PURE__*/ React.createElement(SvgDecreaseIndent, null),
    FFXCShowBcc: /*#__PURE__*/ React.createElement(SvgShowBcc, null),
    FFXCHideBcc: /*#__PURE__*/ React.createElement(SvgHideBcc, null),
    FFXCTextHighlight: /*#__PURE__*/ React.createElement(SvgFabricTextHighlight, null),
    FFXCFontColor: /*#__PURE__*/ React.createElement(SvgFontColor, null),
    FFXCFontColorKorean: /*#__PURE__*/ React.createElement(SvgFontColorKorean, null),
    FFXFontColorA: /*#__PURE__*/ React.createElement(SvgFontColorA, null),
    FFXCSync: /*#__PURE__*/ React.createElement(SvgSync, null),
    FFXCTextNumberFormat: /*#__PURE__*/ React.createElement(SvgTextNumberFormat, null),
    FFXCBody: /*#__PURE__*/ React.createElement(SvgAlignLeft, null),
    // office-bohemia-ux
    FFXCEmoji: /*#__PURE__*/ React.createElement(SvgEmoji, null),
    FFXCShare: /*#__PURE__*/ React.createElement(SvgShare, null),
    FFXCUpload: /*#__PURE__*/ React.createElement(SvgUpload, null),
    FFXCLocaleLanguage: /*#__PURE__*/ React.createElement(SvgLocaleLanguage, null),
    FFXCInfo: /*#__PURE__*/ React.createElement(SvgInfo, null),
    // Calendar
    FFXCUpArrow: /*#__PURE__*/ React.createElement(SvgUp, null),
    FFXCDownArrow: /*#__PURE__*/ React.createElement(SvgDown, null),
    FFXCCloseIcon: /*#__PURE__*/ React.createElement(SvgCalculatorMultiply, null),
    // Duration
    FFXCClock: /*#__PURE__*/ React.createElement(SvgClock, null),
    // AtMentions
    FFXCPersonAdd: /*#__PURE__*/ React.createElement(SvgAddFriend, null),
    FFXCAddCircle: /*#__PURE__*/ React.createElement(SvgAddCircle, null),
    // Dias
    FFXCCalendarEdit: /*#__PURE__*/ React.createElement(SvgEventEdit, null),
    // CheckboxRichText
    FFXCBulbIcon: /*#__PURE__*/ React.createElement(SvgInsights, null),
    FFXContextIcon: /*#__PURE__*/ React.createElement(SvgContextMenu, null),
    // ErrorFramework
    FFXCCancel: /*#__PURE__*/ React.createElement(SvgCancel, null),
    FFXCErrorBadge: /*#__PURE__*/ React.createElement(SvgErrorBadge, null),
    FFXCBlocked: /*#__PURE__*/ React.createElement(SvgBlocked2, null),
    FFXCError: /*#__PURE__*/ React.createElement(SvgError, null),
    // Conversa
    FFXConversation: /*#__PURE__*/ React.createElement(SvgActivityFeed, null),
    FFXReply: /*#__PURE__*/ React.createElement(SvgArrowReply, null),
    FFXDraft: /*#__PURE__*/ React.createElement(SvgDraft, null),
    FFXDraftFilled: /*#__PURE__*/ React.createElement(SvgDraftFilled, null),
    FFXComment: /*#__PURE__*/ React.createElement(SvgComment, null),
    FFXCommentCancel: /*#__PURE__*/ React.createElement(SvgCancel, null),
    FFXCommentDelete: /*#__PURE__*/ React.createElement(SvgCommentDelete, null),
    FFXCommentDeleteFilled: /*#__PURE__*/ React.createElement(SvgCommentDeleteFilled, null),
    FFXCommentEdit: /*#__PURE__*/ React.createElement(SvgEdit, null),
    FFXCommentEditFilled: /*#__PURE__*/ React.createElement(SvgEditFilled, null),
    FFXCommentSend: /*#__PURE__*/ React.createElement(SvgSend, null),
    FFXCommentSubmit: /*#__PURE__*/ React.createElement(SvgCheckMark, null),
    FFXChatMultiple: /*#__PURE__*/ React.createElement(SvgChatMultiple, null),
    FFXChatMultipleFilled: /*#__PURE__*/ React.createElement(SvgChatMultipleFilled, null),
    FFXEmojiAdd: /*#__PURE__*/ React.createElement(SvgEmojiAdd, null),
    // InlineTask
    AddFriend: /*#__PURE__*/ React.createElement(SvgAddFriend, null),
    Cancel: /*#__PURE__*/ React.createElement(SvgCancel, null),
    // QA
    FFXCQuestion: /*#__PURE__*/ React.createElement(SvgUnknown, null),
    FFXCReverseQuestion: /*#__PURE__*/ React.createElement(SvgUnknownReverse, null),
    FFXCHelp: /*#__PURE__*/ React.createElement(SvgHelp, null),
    FFXCHelpMirrored: /*#__PURE__*/ React.createElement(SvgHelpMirrored, null),
    // CatchUpFlyout
    FFXCActivityIcon: /*#__PURE__*/ React.createElement(SvgOfficeCatchUp, null),
    // TrelloIntegration
    FFXCSearch: /*#__PURE__*/ React.createElement(SvgSearch, null),
    FFXCLogout: /*#__PURE__*/ React.createElement(SvgLogout, null),
    FFXCPersonCircle: /*#__PURE__*/ React.createElement(SvgPersonCircle, null),
    // Video
    FFXCVideoAdd: /*#__PURE__*/ React.createElement(SvgVideoAdd, null),
    // Forms Poll
    // This is consumed by our Forms 2P partners - do not remove without confirming
    // Forms is no longer using it: https://office.visualstudio.com/OC/_git/Forms-Fluid
    FFXCPoll: /*#__PURE__*/ React.createElement(SvgFluentPoll20Filled, null),
    // Link Unfurl
    FFXCGlobe: /*#__PURE__*/ React.createElement(SvgGlobe, null),
    // Trello
    FFXCTrello: /*#__PURE__*/ React.createElement(SvgTrello, null),
    //Trello disabled
    FFXCTrelloDisabled: /*#__PURE__*/ React.createElement(SvgTrelloDisabled, null),
    // Jira
    FFXCJira: /*#__PURE__*/ React.createElement(SvgJira, null),
    //Jira disabled
    FFXCJiraDisabled: /*#__PURE__*/ React.createElement(SvgJiraDisabled, null),
    // Planner
    FFXCPlanner: /*#__PURE__*/ React.createElement(SvgPlanner, null),
    // Copilot
    FFXCCopilot: /*#__PURE__*/ React.createElement(SvgCopilot, null),
    FFXCCopilotColorful: /*#__PURE__*/ React.createElement(SvgCopilotColorful, null),
    FFXCLightbulbFilled: /*#__PURE__*/ React.createElement(SvgLightbulbFilled, null),
    FFXCPencilDraftFilled: /*#__PURE__*/ React.createElement(SvgPencilDraftFilled, null),
    FFXCMapFilled: /*#__PURE__*/ React.createElement(SvgMapFilled, null),
    FFXChatBubbleSparkleFilled: /*#__PURE__*/ React.createElement(SvgChatBubbleSparkleFilled, null),
    FFXCSparkleShimmer: /*#__PURE__*/ React.createElement(SvgSparkleShimmer, null),
    FFXCThumbLike: /*#__PURE__*/ React.createElement(SvgThumbLike, null),
    FFXCThumbLikeFilled: /*#__PURE__*/ React.createElement(SvgThumbLikeFilled, null),
    FFXCThumbDislike: /*#__PURE__*/ React.createElement(SvgThumbDislike, null),
    FFXCThumbDislikeFilled: /*#__PURE__*/ React.createElement(SvgThumbDislikeFilled, null),
    FFXCStopCircle: /*#__PURE__*/ React.createElement(SvgStopCircle, null),
    FFXCStatusErrorFull: /*#__PURE__*/ React.createElement(SvgStatusErrorFull, null),
    FFXCCriticalErrorSolid: /*#__PURE__*/ React.createElement(SvgCriticalErrorSolid, null),
    FFXCWarningSolid: /*#__PURE__*/ React.createElement(SvgWarningSolid, null),
    FFXCUndoThick: /*#__PURE__*/ React.createElement(SvgUndoThick, null),
    FFXCChatWarning: /*#__PURE__*/ React.createElement(SvgChatWarning, null),
    // WXP / M365
    FFXFluentIconWord: /*#__PURE__*/ React.createElement(SvgFluentIconWord, null),
    FFXFluentIconExcel: /*#__PURE__*/ React.createElement(SvgFluentIconExcel, null),
    FFXFluentIconPowerPoint: /*#__PURE__*/ React.createElement(SvgFluentIconPowerPoint, null),
    // Editor
    FFXCArrowBetweenDown: /*#__PURE__*/ React.createElement(SvgArrowBetweenDown, null),
    FFXCArrowBetweenUp: /*#__PURE__*/ React.createElement(SvgArrowBetweenUp, null)
};
const localizedIcons = {
    FFXCCalendarMirrored: /*#__PURE__*/ React.createElement(SvgCalendarMirrored, null),
    FFXCBulletedListMirrored: /*#__PURE__*/ React.createElement(SvgBulletedListMirrored, null),
    FFXCClipboardListMirrored: /*#__PURE__*/ React.createElement(SvgClipboardListMirrored, null),
    FFXCNumberedListMirrored: /*#__PURE__*/ React.createElement(SvgNumberedListMirrored, null),
    FFXCChecklistMirrored: /*#__PURE__*/ React.createElement(SvgChecklistMirrored, null),
    FFXCIncreaseIndentMirrored: /*#__PURE__*/ React.createElement(SvgIncreaseIndentMirrored, null),
    FFXCDecreaseIndentMirrored: /*#__PURE__*/ React.createElement(SvgDecreaseIndentMirrored, null),
    FFXCBodyMirrored: /*#__PURE__*/ React.createElement(SvgAlignRight, null),
    FFXSendMirrored: /*#__PURE__*/ React.createElement(SvgSendMirrored, null),
    FFXCSeeMoreMirrored: /*#__PURE__*/ React.createElement(SvgReplyMirrored, null),
    FFXQuickSyncMirrored: /*#__PURE__*/ React.createElement(SvgCustomListMirrored, null),
    FFXCBoldF: /*#__PURE__*/ React.createElement(SvgBoldF, null),
    FFXCBoldT: /*#__PURE__*/ React.createElement(SvgBoldT, null),
    FFXCBoldK: /*#__PURE__*/ React.createElement(SvgBoldK, null),
    FFXCBoldBulgarian: /*#__PURE__*/ React.createElement(SvgBoldBulgarian, null),
    FFXCBoldKazakh: /*#__PURE__*/ React.createElement(SvgBoldKazakh, null),
    FFXCBoldSerbian: /*#__PURE__*/ React.createElement(SvgBoldSerbian, null),
    FFXCBoldP: /*#__PURE__*/ React.createElement(SvgBoldP, null),
    FFXCBoldG: /*#__PURE__*/ React.createElement(SvgBoldG, null),
    FFXCBoldN: /*#__PURE__*/ React.createElement(SvgBoldN, null),
    FFXCBoldRussian: /*#__PURE__*/ React.createElement(SvgBoldRussian, null),
    FFXCBoldKorean: /*#__PURE__*/ React.createElement(SvgBoldKorean, null),
    FFXCItalicC: /*#__PURE__*/ React.createElement(SvgItalicC, null),
    FFXCItalicD: /*#__PURE__*/ React.createElement(SvgItalicD, null),
    FFXCItalicT: /*#__PURE__*/ React.createElement(SvgItalicT, null),
    FFXCItalicL: /*#__PURE__*/ React.createElement(SvgItalicL, null),
    FFXCItalicKazakh: /*#__PURE__*/ React.createElement(SvgItalicKazakh, null),
    FFXCItalicS: /*#__PURE__*/ React.createElement(SvgItalicS, null),
    FFXCItalicK: /*#__PURE__*/ React.createElement(SvgItalicK, null),
    FFXCItalicKorean: /*#__PURE__*/ React.createElement(SvgItalicKorean, null),
    FFXCUnderlineS: /*#__PURE__*/ React.createElement(SvgUnderlineS, null),
    FFXCUnderlineP: /*#__PURE__*/ React.createElement(SvgUnderlineP, null),
    FFXCUnderlineA: /*#__PURE__*/ React.createElement(SvgUnderlineA, null),
    FFXCUnderlineSerbian: /*#__PURE__*/ React.createElement(SvgUnderlineSerbian, null),
    FFXCUnderlineRussian: /*#__PURE__*/ React.createElement(SvgUnderlineRussian, null),
    FFXCUnderlineKorean: /*#__PURE__*/ React.createElement(SvgUnderlineKorean, null),
    FFXCStrikethroughKorean: /*#__PURE__*/ React.createElement(SvgStrikethroughKorean, null)
};
export const SvgComponentsIcons = {
    name: 'components',
    icons
};
export const SvgComponentsLocalizedIcons = {
    name: 'components-localized',
    icons: localizedIcons
};
